/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HorseDetailsLocation } from '../models/HorseDetailsLocation';
import { HttpFile } from '../http/http';

export class Point {
    'point': HorseDetailsLocation;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "point",
            "baseName": "point",
            "type": "HorseDetailsLocation",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Point.attributeTypeMap;
    }

    public constructor() {
    }
}

